import {
  Pagination,
  Table,
  TableCell,
  TableContainer,
  TableFooter,
  TableHeader,
  WindmillContext,
} from "@windmill/react-ui";
import { Link } from 'react-router-dom';
import HistoryTable2 from "components/history/HistoryTable2";
import HistoryServices from "services/HistoryServices";
import useProductFilter from "hooks/useProductFilter";

import LineChart from "components/chart/LineChart/LineChart";
import PieChart from "components/chart/Pie/PieChart";
import CardItem from "components/dashboard/CardItem";
import CardItemTwo from "components/dashboard/CardItemTwo";
import CardItemOne from "components/dashboard/CardItemOne";
import ChartCard from "components/chart/ChartCard";
import OrderTable from "components/order/OrderTable";
import TableLoading from "components/preloader/TableLoading";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import * as dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import AdminServices from "services/AdminServices";
import { useTranslation } from "react-i18next";
import { ImCreditCard, ImStack } from "react-icons/im";
import OrderServices from "services/OrderServices";
import AnalyticsServices from "services/AnalyticsServices";
import Skeleton from "react-loading-skeleton";
import { privilegeMatches } from "utils/privileges";
//internal import

dayjs.extend(isBetween);
dayjs.extend(isToday);
dayjs.extend(isYesterday);

const Dashboard = () => {
  const { globalSetting } = useFilter();
  const { mode } = useContext(WindmillContext);
  const currency = globalSetting?.default_currency || "$";

  const { currentPage, limitData, handleChangePage, lang } = useContext(SidebarContext);

  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [departmentCounts, setDepartmentCounts] = useState([])
  const [contactQuoteCounts, setContactQuoteCounts] = useState([])
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const {
    serviceData,
    filename,
    isDisabled,
    handleSelectFile,
    handleUploadMultiple,
    handleRemoveSelectFile,
  } = useProductFilter(data?.Services);

  const readAdminProfile = () => {
    try {
      const stored = localStorage.getItem("admin");
      if (stored) return JSON.parse(stored);

      const cookie = Cookies.get("adminInfo");
      if (cookie) return JSON.parse(cookie);
    } catch (e) {
      return null;
    }
    return null;
  };

  const [adminProfile, setAdminProfile] = useState(readAdminProfile);
  const Previleges = (adminProfile?.previleges || []).map(
    (previlege) => previlege.slug
  );
  const Departments = (adminProfile?.departments || []).map((dep) => dep.title);

  useEffect(() => {
    async function ensureAdminProfile() {
      if (adminProfile?.previleges?.length) return;

      try {
        const adminInfoString = Cookies.get("adminInfo");
        if (!adminInfoString) return;

        const adminInfo = JSON.parse(adminInfoString);
        if (!adminInfo?.id) return;

        const response = await AdminServices.getStaffById(adminInfo.id);
        if (response?.data) {
          localStorage.setItem("admin", JSON.stringify(response.data));
          setAdminProfile(response.data);
        }
      } catch (error) {
        console.error("Error loading admin profile:", error);
      }
    }

    ensureAdminProfile();
  }, [adminProfile?.previleges?.length]);

  useEffect(() => {
    async function fetchCategories() {
      try {
        setLoading(true);
        const response = await AnalyticsServices.getAll();
        const categories = response?.categories || [];
        const departmentCountsData = response?.departmentCounts || [];
        const contactQuote = response?.contact_quote || [];

        setCategories(categories.filter((cat) => {
          if (cat.name == 'Blogs') {
            return privilegeMatches(Previleges, 'view_blog')
          } else if (cat.name == 'Careers') {
            return privilegeMatches(Previleges, 'view_career')
          } else if (cat.name == 'Categories') {
            return privilegeMatches(Previleges, 'view_category')
          } else if (cat.name == 'Project') {
            return privilegeMatches(Previleges, 'view_project')
          } else if (cat.name == 'References') {
            return privilegeMatches(Previleges, 'view_reference')
          } else if (cat.name == 'Service') {
            return privilegeMatches(Previleges, 'view_service')
          }
        }));
        setDepartmentCounts(departmentCountsData.filter((dep) => {
          return Departments.includes(dep.name)
        }));
        setContactQuoteCounts(contactQuote.filter((item) => {
          return (
            (item.name == 'Contact' && privilegeMatches(Previleges, 'view_contact'))
            ||
            (item.name == 'Quote' && privilegeMatches(Previleges, 'view_quote'))
          )
        }));

        const response2 = await HistoryServices.getLastAdminHistory();

        setData(response2?.data || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchCategories();
  }, [Previleges.join(","), Departments.join(",")]);


  // console.log('cat', categories)
  // console.log('departmentCounts', departmentCounts)
  return (
    <>
      {/* <PageTitle>{t("DashboardOverview")}</PageTitle> */}
      <br />
      <div className="grid gap-2 md:grid-cols-1">
        <div className={`md:${Previleges.includes('view_history')?'col-span-2':'col-span-3'} grid gap-2 md:grid-cols-3 xl:grid-cols-3`}>
          {contactQuoteCounts?.map((con_quote, index) => (
            <Link to={con_quote.route} key={index}>

              <CardItemOne
                mode={mode}
                currency={currency}
                title={con_quote.name}
                icon={con_quote.icon}
                cash={con_quote.in_progress}
                card={con_quote.completed}
                credit={con_quote.canceled}
                price={con_quote.count}
                className="text-white dark:text-orange-100 bg-orange"
                loading={loading}
              />


            </Link>
          ))}

          <div>
          </div>

          {departmentCounts?.map((department, index) => (
            <Link to={`/contacts/${department.id}`} key={index}>

              <CardItemOne
                mode={mode}
                currency={currency}
                title={department.name}
                icon={department.icon}
                cash={department.in_progress}
                card={department.completed}
                credit={department.canceled}
                price={department.count}
                className="text-white dark:text-orange-100 bg-dark"
                loading={loading}
              />


            </Link>
          ))}


          {loading && (
            <>
              <Skeleton className="text-white dark:text-orange-100 bg-dark" />
              <Skeleton className="text-white dark:text-orange-100 bg-dark" />
              <Skeleton className="text-white dark:text-orange-100 bg-dark" />
              <Skeleton className="text-white dark:text-orange-100 bg-dark" />
            </>
          )}
          {/* </div> */}


          {/* <div className="grid gap-4 mb-8 md:grid-cols-3 xl:grid-cols-3"> */}
          {categories?.map((category, index) => (
            <Link to={category.route} key={index}>
              <CardItem
                mode={mode}
                currency={currency}
                title={category.name}
                Icon={category.icon}
                quantity={category.count}
                className="text-white dark:text-orange-100 bg-orange"
                loading={loading}
              />
            </Link>
          ))}

          {loading && (
            <>
              <Skeleton className="text-white dark:text-orange-100 bg-orange" />
              <Skeleton className="text-white dark:text-orange-100 bg-orange" />
              <Skeleton className="text-white dark:text-orange-100 bg-orange" />
              <Skeleton className="text-white dark:text-orange-100 bg-orange" />
            </>
          )}
        </div>
        {
          Previleges.includes('view_history') && (
            <div className="md:col-span-1" style={{maxHeight: '535px', overflowY: 'scroll', borderRadius: '5px'}}>
              {serviceData?.length !== 0 ? (
                <TableContainer className="mb-8 rounded-b-lg">
                  <Table>
                    <TableHeader>
                      <tr>

                        {/* <TableCell>{t("ID")}</TableCell> */}
                        <TableCell>{t("ADMINNAMETbl")}</TableCell>
                        <TableCell>{t("ACTIONTbl")}</TableCell>
                        <TableCell>{t("Date")}</TableCell>
                      </tr>
                    </TableHeader>
                    <HistoryTable2

                      data={data}
                    />
                  </Table>

                </TableContainer>
              ) : (
                <NotFound title="History" />
              )}
            </div>
          )
        }
      </div>
    </>
  );
};

export default Dashboard;
